import { makeStyles } from "@fluentui/react-components";

export const useFallbackRuleCardStyles = makeStyles({
  fallbackRuleCard: {
    gap: "1rem",
    padding: "1.5rem",
    position: "relative",
  },
  fallbackRuleCardHandle: {
    display: "inline-flex",
    position: "absolute",
    top: "50%",
    left: "0.3125rem",
    transform: "translateY(-50%)",
  },
  fallbackRuleCardActionsRow: {
    position: "absolute",
    top: "0.75rem",
    right: "0.75rem",
  },
  exampleLanguageIcon: {
    transform: "scaleX(-1)",
  },
});
